import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { NamePatternDtoTypeEnum, NamePatternPageDto } from '../types';

export type NamePatternsFilters = {
  overrideName?: string;
  baseName?: string;
  page: number;
  limit: number;
};

export const useNamePatterns = (type: NamePatternDtoTypeEnum, filters: NamePatternsFilters) => {
  const { projectId } = useParams();

  return useQuery<NamePatternPageDto>({
    queryKey: ['name-patterns', projectId, type, filters],
    queryFn: () =>
      apiClient.get(`/v1/projects/${projectId}/name-patterns/${type}`, {
        params: filters,
      }),
    placeholderData: keepPreviousData,
    enabled: !!projectId,
  });
};
